import React from 'react';

const MatchAnalysis = ({ item }) => {
  const formatTimeAgo = (dateString) => {
    if (!dateString) return 'Unknown';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60
    };

    for (const [unit, seconds] of Object.entries(intervals)) {
      const value = Math.floor(diffInSeconds / seconds);
      if (value >= 1) {
        return `${value} ${unit}${value === 1 ? '' : 's'} ago`;
      }
    }
    
    return 'Just now';
  };

  return (
    <div className="bg-gray-50 rounded-lg p-6">
      <h5 className="text-lg font-medium text-gray-900 mb-6">Match Analysis</h5>
      <div className="space-y-6">
        {/* Field Scores */}
        {item.metadata?.field_scores && (
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <h6 className="text-sm font-medium text-gray-700 mb-4">Field Relevance</h6>
            <div className="space-y-4">
              {Object.entries(item.metadata.field_scores).map(([field, score]) => (
                <div key={field} className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-600 capitalize w-24">
                    {field.replace('_', ' ')}
                  </span>
                  <div className="flex items-center flex-grow ml-4">
                    <div className="flex-grow h-2 bg-gray-100 rounded-full overflow-hidden mr-3">
                      <div 
                        className="h-full bg-blue-500 rounded-full transition-all duration-500 ease-in-out"
                        style={{ width: `${score * 100}%` }}
                      />
                    </div>
                    <span className="text-sm text-gray-600 w-16 text-right">
                      {(score * 100).toFixed(1)}%
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Temporal Decay Score */}
        {item.metadata?.temporal_decay !== undefined && (
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <h6 className="text-sm font-medium text-gray-700 mb-4">Time Relevance</h6>
            <div className="space-y-3">
              <div className="flex items-center">
                <div className="flex-grow h-2 bg-gray-100 rounded-full overflow-hidden mr-3">
                  <div 
                    className="h-full bg-green-500 rounded-full transition-all duration-500 ease-in-out"
                    style={{ width: `${item.metadata.temporal_decay * 100}%` }}
                  />
                </div>
                <span className="text-sm font-medium text-gray-600 w-16 text-right">
                  {(item.metadata.temporal_decay * 100).toFixed(1)}%
                </span>
              </div>
              <p className="text-xs text-gray-500">
                Time since event: {formatTimeAgo(item.metadata.event_date)}
              </p>
            </div>
          </div>
        )}

        {/* Overall Score */}
        <div className="bg-white rounded-lg p-4 shadow-sm">
          <h6 className="text-sm font-medium text-gray-700 mb-4">Overall Match Score</h6>
          <div className="flex items-center">
            <div className="flex-grow h-3 bg-gray-100 rounded-full overflow-hidden mr-3">
              <div 
                className="h-full bg-purple-500 rounded-full transition-all duration-500 ease-in-out"
                style={{ width: `${item.score * 100}%` }}
              />
            </div>
            <span className="text-sm font-medium text-gray-700 w-16 text-right">
              {(item.score * 100).toFixed(1)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchAnalysis;